import { action, thunkOn } from "easy-peasy";

import { RulesModelInteface } from "./rulesModelInterface";

const rulesModel: RulesModelInteface = {
  rules: [],
  setRules: action((state, payload) => {
    state.rules = payload;
  }),
  addRule: action((state, payload) => {
    payload.id = 0;
    state.rules.push(payload);
  }),
  removeRule: action((state, payload) => {
    state.rules.splice(payload, 1);
    state.rules.forEach((rule, index) => {
      rule.index = index;
    });
  }),
  removeRuleByFieldId: action((state, payload) => {
    state.rules = state.rules.filter((rule) => rule.agent !== payload && rule.target !== payload);
  }),
  updateRule: action((state, payload) => {
    state.rules[payload.index] = payload;
  }),
  moveRuleUp: action((state, payload) => {
    const index = payload;
    if(index>0){
      const ruleList = state.rules.map((rule, index) => ({ ...rule, index }));
      const indexAbove = index - 1;
      const rule = ruleList[index];
      ruleList[index] = ruleList[indexAbove];
      ruleList[indexAbove] = rule;
      state.rules = ruleList;
    }
  }),
  moveRuleDown: action((state, payload) => {
    const index = payload;
    if(index < state.rules.length-1){
      const ruleList = state.rules.map((rule, index) => ({ ...rule, index }));
      const indexBelow = index + 1;
      const rule = ruleList[index];
      ruleList[index] = ruleList[indexBelow];
      ruleList[indexBelow] = rule;
      state.rules = ruleList;
    }
  }),
onRuleChange: thunkOn(
    (actions, storeActions) => [
      // The setRule action is not listened here because it is already listened on the formActions
      storeActions.rules.addRule,
      storeActions.rules.removeRule,
      storeActions.rules.updateRule,
      storeActions.rules.moveRuleUp,
      storeActions.rules.moveRuleDown,
      storeActions.rules.setRulesOrderIndexes,
    ],
    (actions, target) => {
      actions.notifyRuleChange(target);
    }
  ),
  notifyRuleChange: action((state, payload) => {}),
  setRulesOrderIndexes: action((state, payload) => {
    state.rules.forEach((rule, index) => {
      rule.orderIndex = index;
    });
  }),
};

export default rulesModel;
